import React, { useContext } from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom'
import { createDamage, getProductByCategory, updateDamage } from '../../../../action';
import { GlobalState } from '../../../../GlobalState'
import { TabTitle } from '../../../../util/titleChanger'
import { ToastContainer, toast } from 'react-toastify'

export default function DamageForm() {
    const { damId } = useParams();
    TabTitle(damId > 0 ? "Update Damage" : "Add Damage");
    const state = useContext(GlobalState);
    const signInUser = JSON.parse(localStorage.getItem('user_data'));

    //Local State
    const [btnName, setBtnName] = useState("Save");
    const [focused, setFocused] = useState(false);
    const [values, setValues] = useState([]);
    const [productListData, setProductListData] = useState([]);
    const onChangeValue = (e) => {
        e.preventDefault();
        setValues({ ...values, [e.target.name]: e.target.value })
    }

    //Import damage state from global state below
    const [damageDetail, setDamageDetail] = state.damageAPI.damageDetail;
    const [damageId, setDamageId] = state.damageAPI.damageId;
    const [callback, setCallback] = state.damageAPI.callback;

    //Import customer state from global state
    const [allCustomers] = state.customerAPI.allCustomers;
    const [showCustomerSuggestions, setShowCustomerSuggestions] = useState(false);
    const [selectCustomer, setSelectCustomer] = useState("");
    const customerSuggestions = allCustomers.filter(customer =>
        customer.first_name.toString().toLowerCase().includes(selectCustomer.toString().toLowerCase())
    )

    const handleCustomerSuggestionClick = (suggestion) => {
        setSelectCustomer(suggestion.first_name + " " + suggestion.last_name)
        setShowCustomerSuggestions(false)
        setValues({
            ...values,
            customerId: suggestion.id
        })
    }

    const onChangeSelectCustomer = (e) => {
        setSelectCustomer(e.target.value)
    }

    //Import category state form global state below
    const [allCategories] = state.categoryAPI.allCategories;
    const [categoryId, setCategoryId] = useState("");

    //For auto complete state
    const [showCategorySuggestions, setShowCategorySuggestions] = useState(false);
    const [selectCategory, setSelectCategory] = useState("")
    const categorySuggestions = allCategories.filter(category =>
        category.name.toString().toLowerCase().includes(selectCategory.toString().toLowerCase())
    )

    const handleCategorySuggestionClick = (suggestion) => {
        setSelectCategory(suggestion.name)
        setShowCategorySuggestions(false)
        setCategoryId(suggestion.id)
        setValues({
            ...values,
            categoryId: suggestion.id
        })

        getProductByCategory(suggestion.id, res => {
            setProductListData(res.data)
        })
    }

    const onChangeSelectCategory = (e) => {
        setSelectCategory(e.target.value)
    }

    //Import product state from global state
    const [productsList] = state.productAPI.productsList;
    const [showProductSuggestions, setShowProductSuggestions] = useState(false);
    const [selectProduct, setSelectProduct] = useState("");
    const productSuggestions = productListData.filter(product =>
        product.name.toString().toLowerCase().includes(selectProduct.toString().toLowerCase())
    )

    const handleProductSuggestionClick = (suggestion) => {
        setSelectProduct(suggestion.name)
        setShowProductSuggestions(false)
        setValues({
            ...values,
            productId: suggestion.id
        })
    }

    const onChangeSelectProduct = (e) => {
        setSelectProduct(e.target.value)
    }

    const handleFocus = (e) => {
        setFocused(true);
    }

    useEffect(() => {
        productsList.data ? setProductListData(productsList.data) : setProductListData([]);

        if (damId > 0) {
            setBtnName("Update");
            setDamageId(damId);

            setValues({
                ...values,
                quantity: damageDetail ? damageDetail.quantity : "0",
                amount: damageDetail ? damageDetail.amount : "0",
                total_amount: damageDetail ? damageDetail.total_amount : "0",
                productId: damageDetail.product ? damageDetail.product.id : "1",
                customerId: damageDetail.customer ? damageDetail.customer.id : "1"
            })

            productListData.map(product => {
                const productId = damageDetail.product ? damageDetail.product.id : "1";
                if (product.id === productId) {
                    setSelectProduct(product.name)
                    setSelectCategory(product.category.name)
                }
            })

            allCustomers.map(customer => {
                const customerId = damageDetail.customer ? damageDetail.customer.id : "1";
                if (customer.id === customerId) {
                    setSelectCustomer(customer.first_name + " " + customer.last_name)
                }
            })
        }


    }, [productsList, allCustomers, allCategories, damageDetail, damId])

    const submitDefault = (e) => {
        e.preventDefault();

        const damageInfo = {
            quantity: values.quantity,
            amount: values.amount,
            total_amount: parseFloat(values.quantity) * parseFloat(values.amount),
            updatedBy: signInUser.id,
            productId: values.productId,
            customerId: values.customerId
        }

        if (damId > 0) {
            updateDamage(damId, damageInfo, res => {
                if (res.status === 200) {
                    toast.success(res.data)
                    setCallback(!callback)
                } else {
                    toast.error(res.data)
                    setCallback(!callback)
                }
            })
        } else {
            damageInfo.createdBy = signInUser.id
            createDamage(damageInfo, res => {
                if (res.status === 200) {
                    toast.success(res.data)
                    setCallback(!callback)
                } else {
                    toast.error(res.data)
                    setCallback(!callback)
                }
            })
        }
    }

    return (
        <div className="form-container">
            <header>Damage Form</header>
            <form onSubmit={submitDefault} className="form">

                <div className="input-box">
                    <label htmlFor="Name">Customer Name</label>
                    <input
                        type="text"
                        name="search"
                        id="search"
                        placeholder='Search here....'
                        value={selectCustomer}
                        onBlur={handleFocus}
                        focused={focused.toString()}
                        onChange={onChangeSelectCustomer}
                        onFocus={() => setShowCustomerSuggestions(true)}
                    />
                    {
                        showCustomerSuggestions && (
                            <ul className="suggestions">
                                {
                                    customerSuggestions.map(suggestion => (
                                        <li key={suggestion.id} onClick={() => handleCustomerSuggestionClick(suggestion)}>
                                            {suggestion.first_name + " " + suggestion.last_name}
                                        </li>
                                    ))
                                }
                            </ul>
                        )
                    }
                </div>

                <div className="input-box">
                    <label htmlFor="Name">Category</label>
                    <input
                        type="text"
                        name="categoryId"
                        id="categoryId"
                        placeholder='Enter Category Name'
                        value={selectCategory}
                        onBlur={handleFocus}
                        focused={focused.toString()}
                        onChange={onChangeSelectCategory}
                        onFocus={() => setShowCategorySuggestions(true)}
                    />
                    {
                        showCategorySuggestions && (
                            <ul className="suggestions">
                                {
                                    categorySuggestions.map(suggestion => (
                                        <li key={suggestion.id} onClick={() => handleCategorySuggestionClick(suggestion)}>
                                            {suggestion.name}
                                        </li>
                                    ))
                                }
                            </ul>
                        )
                    }
                </div>

                <div className="input-box">
                    <label htmlFor="Name">Product Name</label>
                    <input
                        type="text"
                        name="productId"
                        id="productId"
                        placeholder='Enter Product Name'
                        value={selectProduct}
                        onBlur={handleFocus}
                        focused={focused.toString()}
                        onChange={onChangeSelectProduct}
                        onFocus={() => setShowProductSuggestions(true)}
                    />
                    {
                        showProductSuggestions && (
                            <ul className="suggestions">
                                {
                                    productSuggestions.map(suggestion => (
                                        <li key={suggestion.id} onClick={() => handleProductSuggestionClick(suggestion)}>
                                            {suggestion.name}
                                        </li>
                                    ))
                                }
                            </ul>
                        )
                    }
                </div>

                <div className="input-box">
                    <label htmlFor="quantity">Quantity</label>
                    <input
                        type="number"
                        name="quantity"
                        id="quantity"
                        placeholder='Enter Quantity'
                        value={values.quantity || ""}
                        required pattern='^(?:[1-9]|\d\d\d*)$'
                        onBlur={handleFocus}
                        focused={focused.toString()}
                        onChange={onChangeValue}
                    />
                    <span>Quantity should be number and more 1.</span>
                </div>

                <div className="input-box">
                    <label htmlFor="amount">Unit Amount</label>
                    <input
                        type="number"
                        name="amount"
                        id="amount"
                        placeholder='Enter unit amount'
                        value={values.amount || ""}
                        required pattern='^(?:[1-9]|\d\d\d*)$'
                        onBlur={handleFocus}
                        focused={focused.toString()}
                        onChange={onChangeValue}
                    />
                    <span>Unit Price should be number and more 1.</span>
                </div>
                <div className="form-button">
                    <button className="add_new">{btnName}</button>
                </div>
            </form>
            <ToastContainer />
        </div>
    )
}
